module.exports = __webpack_public_path__ + "img/oem3.e62a0fec.png";